<template>
  <div>Rule</div>
</template>

<script>
export default {};
</script>
